export function findFontLicense(
  order:
    | {
        fontLicenses: {
          total: number;
          family: { id: number };
          licenseOption: { id: number };
          faces: { id: number }[];
        }[];
      }
    | null
    | undefined,
  familyId: number,
  licenseOptionId: number,
) {
  if (order == null) {
    return null;
  }

  return order.fontLicenses.find(
    (license) =>
      license?.family?.id === familyId &&
      license?.licenseOption?.id === licenseOptionId,
  );
}

export function isComplementaryFaceSelected(
  fontFace: {
    id: number;
    width: { slug: string; name: string; position: number };
    size: { slug: string; name: string; position: number };
    weight: { slug: string; name: string; position: number };
  },
  selectedFaces: {
    id: number;
    width: { slug: string; name: string; position: number };
    size: { slug: string; name: string; position: number };
    weight: { slug: string; name: string; position: number };
  }[],
): boolean {
  return selectedFaces.some(
    (selectedFace) =>
      fontFace.id !== selectedFace.id &&
      fontFace.width.slug === selectedFace.width.slug &&
      fontFace.size.slug === selectedFace.size.slug &&
      fontFace.weight.slug === selectedFace.weight.slug,
  );
}

export function priceForFace(
  fontFace: {
    id: number;
    width: { slug: string; name: string; position: number };
    size: { slug: string; name: string; position: number };
    weight: { slug: string; name: string; position: number };
    family: { fontFacePrice: number; discountedFontFacePrice: number };
  },
  selectedFaces: {
    id: number;
    width: { slug: string; name: string; position: number };
    size: { slug: string; name: string; position: number };
    weight: { slug: string; name: string; position: number };
  }[],
): number {
  const inCart = selectedFaces.some((f) => f.id === fontFace.id);
  const fontFamily = fontFace.family;

  if (isComplementaryFaceSelected(fontFace, selectedFaces)) {
    if (inCart) {
      return fontFamily.discountedFontFacePrice;
    } else {
      return (
        (fontFamily.fontFacePrice - fontFamily.discountedFontFacePrice) * 2
      );
    }
  } else {
    return fontFamily.fontFacePrice;
  }
}
